/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";

export const IPFormatter = (cellContent, row, rowIndex) => {
  const { ip_country } = row;

  return (
    <>
      <div className="d-flex align-items-center">
        {ip_country ? ip_country : "-"}
      </div>
    </>
  );
};
